import { useEffect, useState } from 'react'

export const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)
    window.addEventListener('orientationchange', handleResize)
    // @TODO: 'orientationchange' event is working on mobile/tablet devices only. Please use another way to handle this case if possible.
    // Refer: https://developer.mozilla.org/en-US/docs/Web/API/Window/orientationchange_event#browser_compatibility

    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('orientationchange', handleResize)
    }
  }, [])

  return { width: windowWidth }
}
